import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import { Link } from 'gatsby';
// import Main from './ArchivePostSingle.styled';
import 'styles/components/ArchivePostSingle.scss';
const ArchivePostSingle = ({
  link,
  title,
  image,
  excerpt,
  category,
  noDetail = false,
  author,
  authorImage,
  date,
}) => (
  <Link to={link} className="archive-post-link">
    <Img alt={title} fluid={image} />
    <div className="blog-padding">
      <div>
        {Array.isArray(category) && category.length > 0 && (
          <span className="blog-tag">
            {category.map((c) => c.name).join(', ')}
          </span>
        )}
        <h2>{title}</h2>
        {noDetail ? '' : <p>{excerpt}</p>}
      </div>
      {noDetail ? (
        <div className="author-details">
          <Img className="author-profile" fluid={authorImage} alt={author} />
          <div className="author-name">
            By
            {` ${author}`}
          </div>
          <div className="date">{date}</div>
        </div>
      ) : (
        ''
      )}
    </div>
  </Link>
);

ArchivePostSingle.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  excerpt: PropTypes.string.isRequired,
  category: PropTypes.array,
  noDetail: PropTypes.bool,
  date: PropTypes.string,
  author: PropTypes.string,
  authorImage: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default ArchivePostSingle;
